import { dispatch, PassportEvents } from '@lib/events/events'
import { analytics } from '@lib/mixpanel/mixpanel'
import { configStore } from '@src/stores/config'
import { get } from 'svelte/store'
import { getAddress } from './blockchain'
import { requestPromoLoyaltyPoints } from '@lib/loyalty'

export async function requestLoyaltyPoints(eventId: number, packageId: string) {
  try {
    const { suiNetwork, clientId, credenza } = get(configStore)

    await requestPromoLoyaltyPoints({
      eventId,
      contractAddress: packageId,
      chainType: 'sui',
      apiUrl: credenza.generalApiUrl,
    })

    const log = {
      suiNetwork,
      clientId,
      packageId,
      eventId,
      from: await getAddress(),
    }

    dispatch(PassportEvents.REQUEST_LOYALTY_POINTS, log)

    analytics.track('cp_request_loyalty', log)
  } catch (err) {
    dispatch(PassportEvents.ERROR, {
      error: { message: err.statusText, title: 'Request loyalty points failed', code: err.status },
    })
    throw err
  }
}
